<template>
  <div
    class="wt2-grid-images-gallery"
    :class="[type, { '-has-scroll': hasMoreThanNumberOfLines }]"
  >
    <slot name="header"></slot>
    <div
      class="-options-box"
      :style="{
        visibility: isVisibleOptions ? 'visible' : 'hidden',
        height: optionsBoxHeight,
      }"
    >
      <div ref="options" class="-inner" :style="{}">
        <div
          class="-option"
          v-for="option in options"
          :key="option.id"
          @click="$emit('click', option.id)"
          :class="{ '-selected': selectedOptionId === option.id }"
        >
          <div class="-option-img" :style="{ height: optionHeight }">
            <img :src="option.src" />
          </div>
          <div class="-option-label" v-if="option.label">
            <span>{{ option.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wt-grid-images-gallery',

  props: {
    type: {
      type: String,
      default: '',
    },

    options: {
      type: Array,
      default: () => [],
    },

    selectedOptionId: {
      type: [String, Number],
    },

    numberOfLines: {
      type: Number,
      default: 2,
    },

    numberOfCols: {
      type: Number,
      default: 3,
    },

    spaceNumber: {
      type: Number,
      default: 12,
    },
  },

  data() {
    return {
      isVisibleOptions: false,
      optionWidth: null,
      optionSpace: null,
      optionsBoxHeight: null,
      optionHeight: null,
    };
  },

  computed: {
    hasMoreThanNumberOfLines() {
      return (
        this.options.length > (this.numberOfLines || 2) * this.numberOfCols
      );
    },

    totalMarginsInRow() {
      return this.spaceNumber * this.numberOfCols + this.spaceNumber;
    },

    currentNumberOfRows() {
      return Math.ceil(this.options.length / this.numberOfCols);
    },
  },

  mounted() {
    this.calculateStylesNextTick();
  },

  watch: {
    options() {
      this.calculateStylesNextTick();
    },
  },

  methods: {
    calculateStylesNextTick() {
      this.isVisibleOptions = false;
      // wait for next tick, so we csn retrieve the width of options
      this.$nextTick(() => {
        this.calculateStyles();
      });
    },

    getOptionProportionalWidth(width) {
      return (width - this.totalMarginsInRow) / this.numberOfCols;
    },

    getTotalOptionsHeight(height) {
      return this.hasMoreThanNumberOfLines
        ? height * this.numberOfLines
        : height * this.currentNumberOfRows;
    },

    galleryReady(el, width) {
      if (!el || !width) {
        return;
      }
      const optionHeight = el.offsetHeight || width;
      const imgWrapper = el.querySelector('.-option-img');
      const optionHeightWithMargin = optionHeight + this.spaceNumber;
      const optionsBoxHeight = this.getTotalOptionsHeight(
        optionHeightWithMargin
      );
      if (this.hasMoreThanNumberOfLines) {
        this.optionsBoxHeight = optionsBoxHeight + this.spaceNumber + 'px';
      }
      if (imgWrapper) {
        this.optionHeight = imgWrapper.offsetHeight + 'px';
      }
      this.isVisibleOptions = true;
      this.$emit('gallery-ready');
    },

    setWidth() {
      this.optionSpace = this.spaceNumber + 'px';
      this.$refs.options.style.setProperty(
        '--image-grid-num-columns',
        this.numberOfCols
      );
      this.$refs.options.style.setProperty(
        '--image-grid-gap',
        this.optionSpace
      );
    },

    calculateStyles() {
      const optionsEl = this.$refs.options;

      if (!optionsEl) {
        console.error('wt-grid-images-gallery: calculateStyles: no optionsEl!');
        return;
      }
      const width = parseInt(getComputedStyle(optionsEl).width, 10);
      const proportionalWidth = this.getOptionProportionalWidth(width);

      this.setWidth(proportionalWidth);

      // make sure that option children has rendered to dom
      this.$nextTick(() => {
        // make sure img, has loaded so height will be correct
        const el =
          optionsEl &&
          (optionsEl.querySelector('.-selected') || optionsEl.firstChild);
        const img = el ? el.querySelector('img') : null;

        if (img) {
          const hasLoaded = img.complete && img.naturalHeight !== 0;

          if (hasLoaded) {
            this.galleryReady(el, width);
          } else {
            img.onload = this.galleryReady.bind(this, el, width);
          }
        } else {
          this.galleryReady(el, width);
        }
      });
    },
  },
};
</script>
